import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ClientLayout } from './client-layout';
import { LazyBoundary } from './RouteFallbacks';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <ClientLayout>
      <LazyBoundary>{children}</LazyBoundary>
    </ClientLayout>
  );
};
